import { Text, TextLink } from 'braid-design-system';
import {
  type AnchorHTMLAttributes,
  type ComponentType,
  type ForwardRefExoticComponent,
} from 'react';

type AnchorProps = Omit<AnchorHTMLAttributes<HTMLAnchorElement>, 'href'> & {
  href: string;
};

export type LinkRendererType =
  | ComponentType<AnchorProps>
  | ForwardRefExoticComponent<AnchorProps>;

export const DefaultLinkRenderer = (props: AnchorProps) => (
  <Text size="small">
    <TextLink {...props} />
  </Text>
);
